import React, { useEffect, useRef } from "react";
import styled from "@emotion/styled";
import { NewText } from "ui";

const StyledSuccessTextWrapper = styled.div`
  width: 430px;
  ${(props) => props.theme.breakpoints.down("sm")} {
    width: 100%; /* Example of responsive behavior */
  }
`;

function FormSuccessMessage() {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  // Focus on the element when it mounts
  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.focus();
    }
  }, []);

  return (
    <StyledSuccessTextWrapper
      ref={wrapperRef}
      tabIndex={-1} // Makes the div focusable
      aria-live="polite"
      aria-label="תודה רבה! נציג יחזור אליכם בקרוב"
    >
      <NewText
        desktopFontSize={38}
        desktopLineHeight={"40px"}
        mobileFontSize={28}
        mobileLineHeight={"32px"}
        desktopFontWeight={500}
        mobileFontWeight={500}
        component={"h2"}
      >
        תודה רבה!
      </NewText>
      <NewText
        desktopFontSize={28}
        desktopLineHeight={"30px"}
        mobileFontSize={18}
        mobileLineHeight={"22px"}
        desktopFontWeight={500}
        mobileFontWeight={500}
        component={"h2"}
      >
        נציג יחזור אליכם בקרוב
      </NewText>
    </StyledSuccessTextWrapper>
  );
}

export default FormSuccessMessage;
